import { useCallback, useState } from 'react';

import Timer from './Timer';
import { Button, Dialog, Typography } from '@cobliteam/ui/components';

import { Analytics } from '@cobliteam/analytics';

import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';

import Icon from '@cobliteam/ui/icons';

const clientVersion = window.__DASHBOARD_MONOREPO_VERSION__;

export function getUpgradeType(newVersion: string, oldVersion?: string) {
  if (!oldVersion) return 'noChange';

  const parseVersion = (version: string) => version.split('.').map(Number);

  const [oldMajor, oldMinor, oldPatch] = parseVersion(oldVersion);
  const [newMajor, newMinor, newPatch] = parseVersion(newVersion);

  if (newMajor > oldMajor) return 'major';
  if (newMinor > oldMinor) return 'minor';
  if (newPatch > oldPatch) return 'patch';

  return 'noChange';
}

function UpdateBanner() {
  const { herbieDashboardVersion } = useFeatureFlags();
  const upgradeType = getUpgradeType(herbieDashboardVersion, clientVersion);
  const showBanner = upgradeType === 'major' || upgradeType === 'minor';
  const [isOpen, setIsOpen] = useState(showBanner);

  const onRefresh = useCallback(() => {
    Analytics.track('Update Banner Refresh Clicked');
    window.location.reload();
  }, []);

  const onFinish = useCallback(() => {
    Analytics.track('Update Banner Timeout');
    setIsOpen(false);
  }, []);

  const onHandleOpenChange = useCallback((open: boolean) => {
    if (!open) Analytics.track('Update Banner Dismissed');
  }, []);

  if (!showBanner) return null;

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open);
        onHandleOpenChange(open);
      }}
    >
      <Dialog.Content className='shadow-xl sm:max-w-[425px]' onEscapeKeyDown={(e: any) => e.preventDefault()} onPointerDownOutside={(e: any) => e.preventDefault()}>
        <div className='flex flex-col items-center justify-center gap-4 py-8'>
          <div className='flex items-center justify-center rounded-full bg-primary p-4'>
            <Icon name='circle-arrow-up' color='white' className='h-8 w-8 ' />
          </div>
          <div className='flex flex-col items-center justify-center space-y-2 text-center'>
            <Typography variant='heading-1'>{upgradeType !== 'major' ? 'Atualização disponível' : 'Atualização obrigatória'}</Typography>
            <p className='text-balance px-3 text-center'>
              A versão <strong>{herbieDashboardVersion}</strong> está disponível. Esta atualização pode incluir novos recursos, correções de bugs e melhorias de desempenho.
            </p>
          </div>
        </div>
        <Dialog.Footer className='flex items-center justify-center gap-2'>
          {upgradeType !== 'major' && (
            <Dialog.Close asChild>
              <Button variant='outlined'>
                Cancelar (<Timer onFinish={onFinish} timer={30} />)
              </Button>
            </Dialog.Close>
          )}
          <Button onClick={onRefresh}>Atualizar agora</Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}

export default UpdateBanner;
